
//Component that displays the Dino Game
const DinoGame = () => {
  return (
    <iframe
      title="Dino Game"
      src="/dinogame.html"
      className="hidden sm:block w-full h-[170px] border-none overflow-hidden"
      scrolling="no"
    />
  );
};

export default DinoGame;
